import React from 'react'
import {Card ,Row, Col} from 'react-bootstrap';




export default function Abou() {
    return (
      <>

<h2 className='section-title' style={{padding:40}}>  الاشراف</h2>

<Row xs={1} md={1} className="g-4">

    <Col align='center'>
      <Card className="card-upgraded acd mxh-33">
        <Card.Img variant="top" src="img/dem.jpeg" />
        <Card.Body>
          <Card.Title>   أ.د/ إيمان زكي موسى الشريف </Card.Title>
          <Card.Text>
            <p className="title">استاذ تكنولوجيا التعليم</p>
            <p className="title">عميد كلية التربية النوعية بجامعة المنيا</p>

          </Card.Text>

          <div className='m24'>
            <a href="#"><i className="fa fa-twitter"></i></a>  
            <a href="#"><i className="fa fa-facebook"></i></a> 
            <a href="#"><i className="fa fa-linkedin"></i></a>  

          </div>

        </Card.Body>
      </Card>
    </Col>







    </Row>
    <p className="p20" style={{padding:30}}>   </p>



    <h2 className="section-title" style={{padding:60}}> فريق العمل والتطوير </h2>


    <Row xs={1} md={2} className="g-4">


    <Col align='center'>

      <Card className="card-upgraded acd mxh-33">
        <Card.Img variant="top" src="img/ali.jpeg" />
        <Card.Body>
          <Card.Title> علي شقراني محمود  </Card.Title>
          <Card.Text>
         مطور الموقع
         <p>
           مسؤول تصميم و تطوير الواجهة الامامية والخلفية  و قواعد البيانات
         </p>
          </Card.Text>

          <div className='m24'>
            <a href="http://twitter.com/AliShakrany"><i className="fa fa-twitter"></i></a>  
            <a href="http://fb.com/Alishakrany"><i className="fa fa-facebook"></i></a> 
            <a href="https://www.linkedin.com/in/ali-shakrany-68b874191/"><i className="fa fa-linkedin"></i></a>  
          </div>

        </Card.Body>
      </Card>
    </Col>


    <Col align='center'>
      <Card className="card-upgraded acd mxh-33">
        <Card.Img variant="top" src="img/abdo.jpeg" />
        <Card.Body>
          <Card.Title>   عبدالرحمن علي خالد</Card.Title>
          <Card.Text>
         مطور الموقع
          
          <p>
            مسئول عن تصميم الواجهة الامامية للموقع
          </p>
          </Card.Text>

          <div className='m24'>
            <a href="#"><i className="fa fa-twitter"></i></a>  
            <a href="https://www.facebook.com/profile.php?id=100038387500467"><i className="fa fa-facebook"></i></a> 
            <a href="#"><i className="fa fa-linkedin"></i></a>  

          </div>

        </Card.Body>
      </Card>
    </Col>
    <p className="p20" style={{padding:30}}>   </p>




</Row>







  </>
    );
  }
  
